<template>
  <div>
    <el-dialog title="支付" :visible.sync="dialogVisible" :append-to-body='true' :lock-scroll="false" width="24rem">
      <div>
        <el-form label-width="80px" :model="payForm">
          <el-form-item label="快捷支付">
            <ul class="paytype">
              <li :class="payForm.payway == item.is ? 'checked' : ''" v-for="(item,index) in payMsg" :key="index" @click="checkWay(index)">
                <img :src="item.src" alt="">
                <span>{{item.title}}</span>
                <i class="el-icon-check"></i>
              </li>
            </ul>
          </el-form-item>
          <el-form-item label="充值金额">
            <el-col :span="16">
              <el-input v-model="payForm.payNumber">
                <template slot="append">元</template>
              </el-input>
            </el-col>
          </el-form-item>
        </el-form>
        <div :class="canSubmit ? 'btnBox' : 'btnBox cant'">
          <a href="javascript:void(0);" class="comButton collection-1 btn-15">
            <span>立即充值</span>
          </a>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dialogVisible: false,
      payMsg: [
        {
          src: require('../../assets/images/wechat.png'),
          title: '微信支付',
          is: 0
        },
        {
          src: require('../../assets/images/pay.png'),
          title: '支付宝支付',
          is: 1
        }
      ],
      payForm: {
        payway: 0,
        payNumber: ''
      },
      canSubmit: false
    }
  },
  methods: {
    checkWay (index) {
      this.payForm.payway = index
    },
    showDialog () {
      this.dialogVisible = true
    }
  },
  mounted () {
  },
  destroyed () {
  },
  watch: {
    'payForm.payNumber' (newVal, oldVal) {
      if (!isNaN(newVal) && newVal > 0) {
        this.canSubmit = true
      } else {
        this.canSubmit = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ button {
  margin: 0;
}
// 移动端样式
@media only screen and (max-width: 1024px) {
  /deep/ .btnBox{
    width: 100%;
    text-align: center;
  }
  .comButton {
    padding: 0.9375rem 2.25rem;
    color: #fff;
    border-radius: 1.75rem;
    cursor: pointer;
    overflow: hidden;
    background-image: linear-gradient(228deg, #3ee3ff, #2e9efd 41%, #186ae8);
    height: 3.125rem;
    font-size: 0.7rem;
  }
  .moreService {
    text-align: center;
  }
  .btn-15:after {
    background-image: linear-gradient(315deg, #0027c2 0, #209dff 74%);
  }
  .cant{
    .comButton {
      padding: 15px 36px;
      color: #fff;
      border-radius: 28px;
      cursor: pointer;
      overflow: hidden;
      background-image: linear-gradient(228deg, #7d7d7d, #7d7d7d 41%, #7d7d7d);
      height: 50px;
    }
    .btn-15:after {
      background-image: linear-gradient(315deg, #7d7d7d 0, #7d7d7d 74%);
    }
  }
  .paytype{
    li{
      border: .125rem solid #dee1e8;
      border-radius: .25rem;
      padding: .75rem 1.625rem;
      margin-bottom: 1.5rem;
      cursor: pointer;
      img{
        width: 1.5rem;
        height: 1.5rem;
        margin-right: .5rem;
      }
      i{
        display: none;
      }
    }
    .checked{
      border: .125rem solid rgb(123, 1, 1);
      position: relative;
      overflow: hidden;
    }
    .checked::before{
      content: "";
      position: absolute;
      width: 0;
      height: 0;
      border-left: 1.5rem solid transparent;
      border-right: 0px solid transparent;
      border-bottom: 1.5rem solid rgb(123, 1, 1);
      bottom: 0;
      right: 0;
    }
    .checked i{
      position: absolute;
      bottom: 0;
      right: 0;
      color: #fff;
      display: block;
    }
  }
}
// pc端样式
@media only screen and (min-width: 1024px) {
  /deep/ .btnBox{
    width: 100%;
    text-align: center;
  }
  .comButton {
    padding: 15px 36px;
    color: #fff;
    border-radius: 28px;
    cursor: pointer;
    overflow: hidden;
    background-image: linear-gradient(228deg, #3ee3ff, #2e9efd 41%, #186ae8);
    height: 50px;
  }
  .btn-15:after {
    background-image: linear-gradient(315deg, #0027c2 0, #209dff 74%);
  }
  .cant{
    .comButton {
      padding: 15px 36px;
      color: #fff;
      border-radius: 28px;
      cursor: pointer;
      overflow: hidden;
      background-image: linear-gradient(228deg, #7d7d7d, #7d7d7d 41%, #7d7d7d);
      height: 50px;
    }
    .btn-15:after {
      background-image: linear-gradient(315deg, #7d7d7d 0, #7d7d7d 74%);
    }
  }
  .paytype{
    display: flex;
    li{
      border: 2px solid #dee1e8;
      border-radius: 4px;
      padding: 12px 26px;
      margin-right: 24px;
      cursor: pointer;
      img{
        width: 24px;
        height: 24px;
        margin-right: 8px;
      }
      i{
        display: none;
      }
    }
    .checked{
      border: 2px solid rgb(123, 1, 1);
      position: relative;
      overflow: hidden;
    }
    .checked::before{
      content: "";
      position: absolute;
      width: 0;
      height: 0;
      border-left: 24px solid transparent;
      border-right: 0px solid transparent;
      border-bottom: 24px solid rgb(123, 1, 1);
      bottom: 0;
      right: 0;
    }
    .checked i{
      position: absolute;
      bottom: 0;
      right: 0;
      color: #fff;
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/comForPc/payPage.vue